import { render, staticRenderFns } from "./data8.vue?vue&type=template&id=88cfda2a&scoped=true&"
import script from "./data8.vue?vue&type=script&lang=js&"
export * from "./data8.vue?vue&type=script&lang=js&"
import style1 from "./data8.vue?vue&type=style&index=1&id=88cfda2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88cfda2a",
  null
  
)

export default component.exports